import LabelValueContainer from "./LabelValueContainer";
import { Typography } from "@material-ui/core";
import YesNoOrChildren from "./YesNoOrChildren";

const ConditionalLabelAndValue = ({ switchValue, value, valueComponent, label, style, skipSeparator, indent }) => {
    const isVisible = valueComponent ? true : Array.isArray(value) ? false : value;
    return (
        <YesNoOrChildren
            {...{
                label,
                switchValue,
                isChildrenVisible: isVisible,
                style,
                indent
            }}
        >
            <LabelValueContainer
                {...{
                    labelComponent: label ? <Typography style={{ fontWeight: indent ? 'normal': "bold" }}>{label}</Typography> : "",
                    valueComponent: valueComponent ? valueComponent : <Typography>{value}</Typography>,
                    style,
                    skipSeparator,
                    indent
                }}
            />
        </YesNoOrChildren>
    );
};

export default ConditionalLabelAndValue;
